'use client'

import type { CSSProperties } from 'react'

import { cn } from '@mntn-dev/ui-utilities'

import { SkeletonBase } from './skeleton-base.tsx'
import { type SkeletonTextSize, skeletonFontSizeMap } from './types.ts'

type SkeletonTextProps = {
  className?: string
  textSize?: SkeletonTextSize
  style?: CSSProperties
}

const SkeletonText = ({
  className,
  textSize = 'base',
  style,
}: SkeletonTextProps) => {
  return (
    <SkeletonBase
      className={cn('w-full rounded', skeletonFontSizeMap[textSize], className)}
      style={style}
    />
  )
}

export { SkeletonText, type SkeletonTextProps }
